const buildUrl = (newOptions: any, allConditionKeys: string[][]) => {
  const arr: any = []
  allConditionKeys.forEach((stringArr: string[]) => {
    arr.push(
      stringArr.map((item: string) => {
        if (newOptions[item] !== undefined && newOptions[item].length !== 0) {
          return newOptions[item].map((option: any) => {
            return option.param.toString().replace('-', '!')
          })
        } else {
          return 'x'
        }
      })
    )
  })
  const queryArr = arr.map((item: any, i: number) => {
    if (i !== 9 && i !== 10) {
      return item.join('_')
    } else {
      if (item.filter((q: string) => q !== 'x').length === 0) {
        return 'x'
      }
      return item
        .map((q: string, i: number) => {
          if (q !== 'x') return i + 1
          return 0
        })
        .filter((q: number) => q !== 0)
        .join('_')
    }
  })
  return queryArr.join('-')
}
export default buildUrl
